import React from "react";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <section className="mt-auto">
      <div className="w-full flex justify-between flex-row border-t-[1px] border-t-textSecondary pt-6">
        <span className="font-thin text-[16px] text-textSecondary">
          Copyright &copy; 2022 Intrance.
          <br className="sm:hidden" /> All Rights Reserved
        </span>
        <div className="flex gap-[60px] text-textSecondary">
          <Link to="#">Privacy Policy</Link>
          <Link to="#">Terms of Use</Link>
        </div>
      </div>
    </section>
  );
};

export default Footer;
